import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import CreateEntityDrawer from '../../common/create-entity-drawer/create-entity-drawer';
import CreateBranchForm from './shelf-form/create-shelf-form';
import ShelvesListing from './shelves-listing/shelves-listing';
import CreateShelfForm from './shelf-form/create-shelf-form';
import { DataResources, ResourceActionType, user_has_data_model_access } from '../../../utils/permissions';
import { useContext } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';

function WarehouseShelves() {
  const {user} = useContext(AuthContext)
  return (
    <div className="content-container">
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 3 }}
        >
          Warehouse Shelves
        </Typography>
        <Grid container spacing={2}>
          <Grid xs={4}></Grid>
          <Grid xs={4}></Grid>
          <Grid xs={4} sx={{ textAlign: 'right' }}>
            <CreateEntityDrawer disabled={!user_has_data_model_access(user, DataResources.SHELF, ResourceActionType.CREATE)}>
              <CreateShelfForm />
            </CreateEntityDrawer>
          </Grid>
          <Grid xs={12}>
            <ShelvesListing />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default WarehouseShelves;
